import { localStorageUtil } from '../../utils/local-storage.util';

export const paginationStorage = localStorageUtil<number>('paginationPage');
